/*
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2026-06-11 09:54:33
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-06-11 10:29:59
 */
import cardAuthClient from './cardAuthClient'
import { unwrapResponse } from './cardAuthService'

// 当前用户可用能量笔数
const GET_USER_ENERGY_ENDPOINT = '/user/getUserEnergy'
// 用户能量钱包列表
const GET_USER_ENERGY_LIST_ENDPOINT = '/user/getUserEnergyWallet'
// 修改用户能量钱包
const SET_USER_ENERGY_WALLET_ENDPOINT = '/user/setUserEnergyWallet'
// 新增用户能量钱包
const ADD_USER_ENERGY_WALLET_ENDPOINT = '/user/addUserEnergyWallet'
// 发送能量
const SEND_USER_ENERGY_ENDPOINT = '/user/sendUserEnergy'

// 获取当前用户可用能量笔数
function getUserEnergy() {
  return cardAuthClient.get(GET_USER_ENERGY_ENDPOINT, {
    params: {},
    includeCsrf: true
  }).then(unwrapResponse)
}

// 获取用户能量钱包列表
function getUserEnergyList() {
  return cardAuthClient.get(GET_USER_ENERGY_LIST_ENDPOINT, {
    params: {},
    includeCsrf: true
  }).then(unwrapResponse)
}

// 修改用户能量钱包
function setUserEnergyWallet({ tag, wallet_id }) {
  const body = { tag, wallet_id }
  return cardAuthClient.post(SET_USER_ENERGY_WALLET_ENDPOINT, body, {
    includeCsrf: true
  }).then(unwrapResponse)
}

// 新增用户能量钱包
function addUserEnergyWallet({ tag, wallet_addons }) {
  const body = { tag, wallet_addons }
  return cardAuthClient.post(ADD_USER_ENERGY_WALLET_ENDPOINT, body, {
    includeCsrf: true
  }).then(unwrapResponse)
}

// 发送能量
function sendUserEnergy({ wallet_id, wallet_addons }) {
  const body = { wallet_id, wallet_addons }
  return cardAuthClient.post(SEND_USER_ENERGY_ENDPOINT, body, {
    includeCsrf: true
  }).then(unwrapResponse)
}

const energyService = {
    getUserEnergy,
    getUserEnergyList,
    setUserEnergyWallet,
    addUserEnergyWallet,
    sendUserEnergy
}

export {
  GET_USER_ENERGY_ENDPOINT,
  GET_USER_ENERGY_LIST_ENDPOINT,
  SET_USER_ENERGY_WALLET_ENDPOINT,
  ADD_USER_ENERGY_WALLET_ENDPOINT,
  SEND_USER_ENERGY_ENDPOINT,
  getUserEnergy,
  getUserEnergyList,
  setUserEnergyWallet,
  addUserEnergyWallet,
  sendUserEnergy,
}

export default energyService